<div
  #clickspotContainer
  class="clickspot-dialog"
  [borderStyle]="border"
  [dropShadow]="!removeDropShadows"
  [style.backgroundColor]="hotspot.backgroundColor"
  [style.backdropFilter]="hotspot.backgroundBlur ? 'blur( ' + hotspot.backgroundBlur + ' )' : ''"
  [class.active]="isOpen"
  [ngClass]="hotspot.cardSize"
  [id]="'clickspot-container-' + id  + '-' + index"
  [attr.data-index]="index + 1"
  (mousedown)="$event.stopPropagation()">

  @if (hotspot.mediaType === mediaTypes.IMAGE || hotspot.mediaType === mediaTypes.VIDEO) {
    <div class="clickspot-media-container">
      @if (hotspot?.mediaImage && (hotspot.mediaType === mediaTypes.IMAGE)) {
        <img
          class="clickspot-media"
          [cropImage]="hotspot.mediaImage | preSignedUrl | async"
          [crop]="hotspot?.mediaImage?.crop"
          [additionalOptions]="hotspot?.mediaImage?.additionalMediaProps"
          alt="">
      }
      @if (isOpen && hotspot?.mediaVideo && (hotspot.mediaType === mediaTypes.VIDEO)) {
        <div class="clickspot-media" [class.video-playing]="videoPlayer?.plyr?.playing">
          <button
            mat-icon-button
            class="button button--primary button--icon button--icon-extra-small play-button"
            [class.d-none]="hotspot?.mediaVideo?.autoplayLoopMode"
            (click)="playHotspotVideo($event, videoPlayer)">
            <lib-icon [icon]="videoPlayer?.plyr?.playing ? 'pause' : 'play'" [size]="16"></lib-icon>
          </button>
          <lib-video
            #videoPlayer
            class="clickspot-video"
            [hideControls]="true"
            [limitToHostHeight]="false"
            [src]="hotspot?.mediaVideo | videoPresign | async"
            [loop]="hotspot?.mediaVideo?.autoplayLoopMode"
            [autoplay]="hotspot?.mediaVideo?.autoplayLoopMode">
          </lib-video>
        </div>
      }
    </div>
  }

  @if (hotspot.text) {
    <div class="clickspot-text-container" [id]="hotspot?.id">
      <ng-scrollbar class="text-scrollbar" thumbClass="custom-scrollbars" orientation="vertical">
        <div class="clickspot-text">
          <div class="ck-text" [autoTextDirection]="isTranslation" [autoTextDirectionValue]="hotspot.text" [rtl]="langcode" [padding]="spacing" [innerHTML]="hotspot.text | safeHtml"></div>
        </div>
      </ng-scrollbar>
    </div>
  }
</div>
